import { render } from "./AIChat.vue?vue&type=template&id=c5f5c5bc&scoped=true"
import script from "./AIChat.vue?vue&type=script&lang=js"
export * from "./AIChat.vue?vue&type=script&lang=js"

import "./AIChat.vue?vue&type=style&index=0&id=c5f5c5bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f5c5bc"]])

export default __exports__